import React, { useEffect, useState } from 'react'
import { 
    MdOutlineCheckCircle,
  MdOutlinePayments,
  MdOutlinePending
} from "react-icons/md";
import PaymentTransTable from './Table/PaymentTransTable'
import RefundModal from './Modal/RefundModal'
import UserPaymentDetails from './Modal/UserPaymentDetails'
import { useDispatch, useSelector } from 'react-redux'
import { getAllPaymentList, getAllPaymentListById, refundtnx } from '../../Redux/paymentsAndTransactionSlice'

const PaymentsAndTransactions = () => {
    const dispatch = useDispatch()
    const selector = useSelector(state => state)

    const [isUserPaymentModal, setIsUserPaymentModal] = useState(false)
    const [isUserPaymentModalData, setIsUserPaymentModalData] = useState(null)

    const [isMenu, setIsMenu] = useState(false)
    const [clickedUserId, setClickedUserId] = useState(null)
    const [isRefundModal, setIsRefundModal] = useState(false)
    const [isRefundModalData, setIsRefundModalData] = useState(null)
    const [userInfo, setuserInfo] = useState({})
    const [size2, setSize2] = useState(10)
    const [pageNo2, setPageNo2] = useState(1)
    const [userId, setUserId] = useState(null);

    const [filter, setFilter] = useState({
        "keyWord": '',
        "pageNo": 1,
        "size": 10,
        "fromDate": "",
        "toDate": "",
        "sortBy": "createdAt",
        "sortOrder": "desc",
        "status": "",
        "type": "",
    })

    const TbaleHeader = [
        { label: '#', sortKey: null },
        { label: ' Transaction ID', sortKey: '_id' },
        { label: 'Payment Type', sortKey: 'type' },
        { label: 'User Name ', sortKey: 'user.fullName' },
        { label: 'Date', sortKey: 'createdAt' },
        { label: 'Status', sortKey: 'status' },
        { label: 'Amount', sortKey: 'amount' },
        { label: 'Action', sortKey: null }
    ]

    const handleSort = (key) => {
        setFilter((prev) => {
            const isSameKey = prev.sortBy === key;
            return {
                ...prev,
                sortBy: key,
                sortOrder: isSameKey && prev.sortOrder === "asc" ? "desc" : "asc",
                pageNo: 1
            };
        });
    };

    const { paymentAndTransactionSlice: { paymentsAndTransaction = [], userTnxList = [], totalpaymentsAndTransaction = null, grosspaymentsAndTransaction=0, netpaymentsAndTransaction=0, userTnxTotal = null } } = selector ? selector : {}

    useEffect(() => {
        dispatch(getAllPaymentList(filter))
    }, [filter])

    const viewAction = (data) => {
        setuserInfo(data?.user)
        setUserId(data?.user?._id)

        let params = {
            "keyWord": '',
            "pageNo": pageNo2,
            "size": size2,
            "fromDate": "",
            "toDate": "",
            "sortBy": "",
            "sortOrder": "asc",
            "userId": data?.user?._id
        }

        dispatch(getAllPaymentListById({ ...params }))
        setIsUserPaymentModal(!isUserPaymentModal); setIsUserPaymentModalData(data); setIsMenu(false)
    }

    const toggleUserPaymentModal = () => {
        setIsUserPaymentModal(!isUserPaymentModal);
    }

    const showMenu = (userId) => {
        if (clickedUserId === userId) {
            setIsMenu(!isMenu);
        } else {
            setClickedUserId(userId);
            setIsMenu(true);
        }
    }

    const handleRefundPayment = (data) => { 
        setIsRefundModal(!isRefundModal); 
        setIsRefundModalData(data); 
        setIsMenu(false) 
    }

    const toggleRefundModal = () => { 
        setIsRefundModal(!isRefundModal); 
    }

    const handleRefundOnChange = (e) => { 
        const { name, value } = e.target; 
        setIsRefundModalData({ ...isRefundModalData, [name]: value }) 
    }

    const handleSubmit = async (e) => {
        e.preventDefault()
        await dispatch(refundtnx({ id: isRefundModalData?._id, filter }))
        setIsRefundModal(false)
    }

    const copyId = () => { }

    const handlePageClick = (data) => {
        setFilter((p) => ({
            ...p,
            pageNo: data.selected + 1
        }))
    }

    const handlePageClick2 = (data) => {
        const newPageNo = data.selected + 1;
        setPageNo2(newPageNo);
        let params = {
            "keyWord": '',
            "pageNo": String(data.selected + 1),
            "size": String(size2),
            "fromDate": "",
            "toDate": "",
            "sortBy": "",
            "sortOrder": "asc",
            "userId": userId
        }
        dispatch(getAllPaymentListById(params))
    }

    // Calculate statistics
    const totalTransactions = totalpaymentsAndTransaction || 0;
    const completedTransactions = paymentsAndTransaction?.filter(t => t?.status === 'completed' || t?.status === 'success')?.length || 0;
    const pendingTransactions = paymentsAndTransaction?.filter(t => t?.status === 'pending')?.length || 0;
    const failedTransactions = paymentsAndTransaction?.filter(t => t?.status === 'failed' || t?.status === 'rejected')?.length || 0;

    // Stats cards data
    const statsCards = [
        {
            title: 'Total Transactions',
            count: totalTransactions,
            icon: MdOutlinePayments,
            color: 'from-blue-500 to-blue-600',
            subtitle: 'All transactions'
        },
        {
            title: 'Gross Revenue',
            count: grosspaymentsAndTransaction,
            icon: MdOutlineCheckCircle,
            color: 'from-emerald-500 to-emerald-600',
            subtitle: 'Gross Revenue'
        },
        {
            title: 'Net Revenue',
            count: netpaymentsAndTransaction,
            icon: MdOutlinePending,
            color: 'from-amber-500 to-amber-600',
            subtitle: 'Net Revenue'
        },
        // {
        //     title: 'Failed',
        //     count: failedTransactions,
        //     icon: MdOutlineCancel,
        //     color: 'from-rose-500 to-rose-600',
        //     subtitle: 'Failed transactions'
        // }
    ];

    return (
        <div className="min-h-screen bg-gray-50/80">
            {/* Header Banner */}
            <div className="bg-gradient-to-r from-[#855DF6] via-[#7B5CF6] to-[#715EFE] shadow-lg relative overflow-hidden">
                <div className="absolute top-0 right-0 w-64 h-64 bg-white/5 rounded-full -mr-20 -mt-20 animate-pulse"></div>
                <div className="absolute bottom-0 left-0 w-48 h-48 bg-white/5 rounded-full -ml-12 -mb-12 animate-pulse"></div>
                <div className="absolute top-1/2 left-1/2 w-96 h-96 bg-white/5 rounded-full -translate-x-1/2 -translate-y-1/2 animate-pulse"></div>
                
                <div className="relative z-10 px-4 md:px-7 py-6 md:py-8">
                    <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
                        <div className="flex items-center gap-3">
                            <div className="p-2.5 bg-white/20 rounded-xl backdrop-blur-sm shadow-lg">
                                <MdOutlinePayments className="w-5 h-5 text-white md:w-6 md:h-6" />
                            </div>
                            <div>
                                <h2 className="text-xl font-bold text-white md:text-2xl dahboardFont tracking-tight">
                                    Payments & Transactions
                                </h2>
                                <p className="text-sm text-white/70 hidden sm:block">
                                    Manage and monitor all financial transactions
                                </p>
                            </div>
                        </div>
                        {/* <div className="flex items-center gap-2">
                            <div className="flex items-center gap-2 px-3 py-1.5 bg-white/20 rounded-full backdrop-blur-sm">
                                <FiRefreshCw className="w-3.5 h-3.5 text-white/70" />
                                <span className="text-xs text-white/80">
                                    {new Date().toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })}
                                </span>
                            </div>
                        </div> */}
                    </div>

                    {/* Stats Cards */}
                    <div className="grid grid-cols-2 gap-3 mt-5 sm:grid-cols-4 md:gap-4">
                        {statsCards.map((card, index) => (
                            <div 
                                key={index}
                                className="bg-white/10 backdrop-blur-sm rounded-xl p-3 md:p-4 border border-white/20 hover:bg-white/20 transition-all duration-300 group"
                            >
                                <div className="flex items-center justify-between">
                                    <div>
                                        <p className="text-lg font-bold text-white uppercase md:text-lg">
                                            {card.title}
                                        </p>
                                        <p className="text-xl font-bold text-white md:text-2xl mt-0.5">
                                            {card.count}
                                        </p>
                                        {card.subtitle && (
                                            <p className="text-[14px] text-white/40 hidden sm:block">
                                                {card.subtitle}
                                            </p>
                                        )}
                                    </div>
                                    <div className={`p-2 rounded-xl bg-gradient-to-br ${card.color} bg-opacity-30 shadow-inner`}>
                                        <card.icon className="w-4 h-4 text-white md:w-5 md:h-5" />
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>

            {/* Main Content */}
            <section className="px-3 py-4 -mt-4 md:px-6 lg:px-10 md:py-6">
                <div className="bg-white rounded-xl shadow-sm hover:shadow-md transition-shadow duration-300 border border-gray-100/80 overflow-hidden">
                    <div className="p-3 md:p-4">
                        <PaymentTransTable 
                            filter={filter} 
                            setFilter={setFilter} 
                            TbaleName={`Transactions History`} 
                            TbaleHeader={TbaleHeader} 
                            TbaleData={paymentsAndTransaction} 
                            copyId={copyId}
                            viewAction={viewAction} 
                            isMenu={isMenu} 
                            showMenu={showMenu} 
                            clickedUserId={clickedUserId} 
                            handleRefundPayment={handleRefundPayment}
                            handlePageClick={handlePageClick} 
                            total={totalpaymentsAndTransaction} 
                            currentSortKey={filter.sortBy}
                            currentSortOrder={filter.sortOrder}
                            onSort={handleSort}
                        />
                    </div>
                </div>
            </section>

            {/* Modals */}
            {isRefundModal && (
                <RefundModal 
                    title={`Refund Payment`} 
                    isRefundModalData={isRefundModalData} 
                    onCancel={toggleRefundModal} 
                    inputValue={isRefundModalData} 
                    onSubmit={handleSubmit} 
                    handleRefundOnChange={handleRefundOnChange} 
                />
            )}

            {isUserPaymentModal && (
                <UserPaymentDetails 
                    pageNo={pageNo2} 
                    userInfo={userInfo} 
                    onClose={toggleUserPaymentModal} 
                    transactions={userTnxList} 
                    title={`Transaction History`} 
                    size={size2} 
                    total={userTnxTotal} 
                    handlePageClick={handlePageClick2} 
                />
            )}
        </div>
    )
}

export default PaymentsAndTransactions